
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/experiences/search/[id]",
      function () {
        return require("private-next-pages/experiences/search/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/experiences/search/[id]"])
      });
    }
  